// @flow
import React, { useEffect, useState } from 'react';
// Components
import ProgressionBar from '../../current-order/components/ProgressionBar';
// helpers
import { priceConverter } from '../../common';
import { isMinAmountPromotionCompleted } from '../utils/isMinAmountPromotionCompleted';
// Styles
import './PromotionNotice.css';
// Types
import type { Promotion } from '../types';

type Props = {
  currentPrice: number,
  promotion: Promotion,
};

const FreeShippingNotice = ({ currentPrice, promotion }: Props) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const promotionRuleWithAmountMin = promotion.promotionRules.find(
    (pr) => pr?.preferences?.amountMin !== undefined
  );

  const promotionValue = promotionRuleWithAmountMin?.preferences?.amountMin ?? 0

  const isPromotionCompleted = isMinAmountPromotionCompleted(promotion, currentPrice);

  return (
    <div className="promotion-notice-main">
      {isPromotionCompleted ? (
        <span className="promotion-notice-text">
          <span className="promotion-notice-main-green">{promotion.name} disponível </span>{' '}
          para essa compra!
        </span>
      ) : (
        <span className="promotion-notice-text">
          Adicione <span className="promotion-notice-main-green">{priceConverter(promotionValue - currentPrice)}</span>  para ganhar
          <span className="promotion-notice-main-green"> {promotion.name}</span>
        </span>
      )}

      {windowWidth > 740 && (
        <ProgressionBar
          absoluteValueToCompare={promotionValue}
          valueToBeCompared={currentPrice}
          barColor="#CE3C25"
          backgroundbarColor="#EDF2F4"
        />
      )}
    </div>
  );
};

export default FreeShippingNotice;
